module.exports = __webpack_public_path__ + "img/Insurama-Icono-200px-1.e25b92c7.jpg";